import React from 'react';
import './Footer.scss';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: Branding */}
        <div className="footer-section">
          <h3>Yamuna Fashion</h3>
          <p>Seamless clothing for a modern lifestyle.</p>
        </div>

        {/* Column 2: Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#products">Products</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Column 3: Contact Info */}
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>Email: contactus@yamunafashion.in</p>
          <p>Phone: +91 7353381765</p>
          <p>Address: #59/D, 1st Floor, 5th Cross, Ganapathi Nagar, Rajgopal Nagar Main Road, Peenya 3rd Phase, Bangalore - 560058</p>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        <p>© 2024 Yamuna Fashion. All rights reserved. Design & Developed by  <a href='https://www.prajnansoftwares.com/aboutus' target="_blank" >Prajnan Software Pvt Ltd.</a></p>
      </div>
    </footer>
  );
};

export default Footer;
